import React from "react";

export const GameContext = React.createContext({
  nameState: "",
  setNameState: (newName: string) => {},
  lobbyKey: "",
  setLobbyKey: (newLobbyKey: string) => {},
});
